export const WalletStaticData = {
  myAccountText: 'My Account',
  walletText: 'Wallet',
  detailsText: 'Details',
  transactionDetailsText: 'Transaction Details',
  totalBalanceText: 'Total Balance',
  lockedEarningText: 'Locked earning',
  totalWithdrawalText: 'Total Withdrawal',
  lastWithdrawalText: 'Last Withdrawal',
  allText: 'All',
  receivedText: 'Received',
  withdrawalText: 'Withdrawal',
  otherText: 'Other',
};

export const WalletHindiData = {
  myAccountText: 'मेरा खाता',
  walletText: 'बटुआ',
  detailsText: 'विवरण',
  transactionDetailsText: 'लेन-देन विवरण',
  totalBalanceText: 'कुल शेष',
  lockedEarningText: 'लॉक कमाई',
  totalWithdrawalText: 'कुल निकासी',
  lastWithdrawalText: 'अंतिम निकासी',
  allText: 'सभी',
  receivedText: 'प्राप्त',
  withdrawalText: 'निकासी',
  otherText: 'अन्य',
};

export const WalletArabicData = {
  myAccountText: 'حسابي',
  walletText: 'المحفظة',
  detailsText: 'التفاصيل',
  transactionDetailsText: 'تفاصيل المعاملة',
  totalBalanceText: 'الرصيد الإجمالي',
  lockedEarningText: 'أرباح مقفلة',
  totalWithdrawalText: 'إجمالي السحب',
  lastWithdrawalText: 'آخر سحب',
  allText: 'الكل',
  receivedText: 'مستلم',
  withdrawalText: 'سحب',
  otherText: 'أخرى',
};
